<template>
  <div class="KCCSH_Class">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          :model="searchForm"
          label-width="90px"
          style="display: flex"
          label-position="left"
        >
          <el-form-item label="化学品:" style="">
            <el-input
              v-model="searchForm.hxpMc"
              placeholder="请输入化学品"
            />
          </el-form-item>
          <el-form-item label="仓库名称:">
            <el-input
              v-model="searchForm.ckMc"
              placeholder="请输入仓库名称"
            />
          </el-form-item>
          <el-button
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            size="small"
            class="chongzhiButton"
            icon="el-icon-refresh-right"
            round
            @click="reset"
          >重置</el-button>
        </el-form>
      </div>
    </div>
    <div
      style="
        width: 95%;
        max-width: 1518px;
        margin: 0 auto;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 51px;
        margin: 0 auto;
      "
    >
      <div class="tablemes">
        <div
          style="
            background-color: #f2f2f2;
            padding: 10px;
            border: 1px solid #f2f2f2;
          "
        >
          <el-button
            v-preventReClick
            icon="el-icon-upload2"
            size="small"
            @click="linkout"
          >导出</el-button>
        </div>
        <el-table
          :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column v-if="false" align="center" prop="id" label="id" />
          <el-table-column v-if="false" align="center" prop="ckId" label="ckId" />
          <el-table-column
            v-if="false"
            align="center"
            prop="hxpBm"
            label="化学品编码"
          />
          <el-table-column align="center" prop="hxpMc" label="化学品名称" />
          <el-table-column align="center" prop="ckMc" label="仓库名称" />
          <el-table-column align="center" prop="kcl" label="库存量" />
          <el-table-column
            v-if="false"
            align="center"
            prop="kclDw"
            label="单位编码"
          />
          <el-table-column align="center" prop="kclDwLabel" label="单位" />
          <el-table-column align="center" prop="ckbgy" label="保管员" />
          <el-table-column align="center" prop="ckbgyDh" label="保管员联系方式" />
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                v-preventReClick
                style="margin: auto"
                size="mini"
                type="primary"
                icon="el-icon-document"
                @click="handleQuery(scope.$index, scope.row)"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager,next,jumper,total,sizes"
          :page-sizes="[10, 20, 30, 40]"
          :total="total"
          :page-size="pagesize"
          class="el-page"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>

    <el-dialog
      v-if="dialogVisible"
      :close-on-click-modal="false"

      :close-on-press-escape="false"
      title="查看库存信息"
      :visible.sync="dialogVisible"
      destroy-on-close
      center
      width="953px"
    >
      <KCdialog :content="content" />
    </el-dialog>
    <!-- <el-dialog
    :close-on-click-modal=false
  :closeOnPressEscape=false

      title="新增库存初始化"
      :visible.sync="dialogVisible2"
      destroy-on-close
      v-if="dialogVisible2"
      center
      width="953px"
    >
      <KCAdd></KCAdd>
    </el-dialog> -->
  </div>
</template>
<script>
import KCdialog from '@/components/Kcgl/KCdialog'
// 获取接口地址
import { excelwriter, getCkkc, getCKKcList } from '@/assets/js/ckkc'
// import KCAdd from "./KCAdd.vue";
export default {
  components: { KCdialog },
  props: {},
  data() {
    return {
      leixing: '',
      content: {},
      titleText: '查看库存信息',
      dialogVisible: false,
      dialogVisible2: false,
      tableData: [
        //   {
        //   "id": "zzyzd202111272203130000000000001",
        //   "ckId": "zzyzd202111271052220000000000001",//仓库主键
        //   "hxpBm": "201",//化学品编码
        //   "kcl": 500000,//库存量
        //   "kclDw": "2",//库存量单位
        //   "kclDwLabel": "千克",//库存量单位Label
        //   "hxpMc": "苯乙酸",//化学品
        //   "ckMc": "测试仓库",//仓库名称
        //   "ckbgy": "仓管员1",//保管员
        //   "ckbgyDh": "18353522009"//保管员电话
        // }
      ], // 表格数据
      total: null, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      searchForm: {
        hxpMc: '',
        ckMc: ''
      },

      multipleSelection: []
    }
  },
  mounted() {
    // 获取列表
    this.getlist()
  },
  methods: {
    // 获取列表
    getlist() {
      getCKKcList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    searchbtn() {
      // 获取列表
      this.getlist()
    },
    reset() {
      this.searchForm.hxpMc = ''
      this.searchForm.ckMc = ''
      // 获取列表
      this.getlist()
    },
    // 导出
    linkout() {
      excelwriter(this.searchForm).then((res) => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = '下载文件' + '.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
      })
    },

    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getlist()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.getlist()
    },

    handleQuery(index, row) {
      getCkkc(row.id, {
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      }).then((e) => {
        this.content = e.data.data
        this.dialogVisible = true
      })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 80px 30px !important;
}
/deep/.el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: middle !important;
}
/deep/.el-table--border {
  border-right: none;
  border-bottom: none;
  z-index: 0 !important;
}
.KCCSH_Class {
  .headerSearch {
    width: 95%;
    max-width: 1518px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }

  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      // width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      // width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .addButton {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-button--primary {
      color: #fff;
      // width: 59px;
      // height: 26px;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .editButton {
      color: #fff;
      width: 59px;
      height: 26px;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
  .el-page {
    // width: 90px;
    // height: 39px;
    .el-pager {
      .active {
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
